import React from "react";
import { ListGroup, Image } from "react-bootstrap";
import moment from "moment";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import imageDefault from "../../../assets/corporative/imageDefault.png";

const ChallengeCard = ({ challenge }) => {
  return (
    <div className="mb-4 w-100">
      <PerfectScrollbar
        className="overflow-x-hidden w-100  px-2 w-100"
        style={{
          maxHeight: "20rem",
          maxWidth: "25rem",
          minWidth: "25rem",
          width: "calc(100% - 2rem)",
          overflowX: "hidden",
        }}
      >
        <div className="d-flex justify-content-between flex-column">
          <div className="d-flex flex-column align-items-center ">
            <h5 className="mb-1">{challenge.name}</h5>

            <img
              className="ms-2 me-1"
              style={{
                objectFit: "cover",
                width: "70px",
                maxHeight: "100%",
                maxWidth: "100%",
                height: "70px",
                borderRadius: "50%",
              }}
              src={challenge?.logo || imageDefault}
            ></img>
          </div>
          <hr></hr>
          <div className=" d-flex">
            <div
              className="col-6 text-start"
              style={{ fontSize: "calc(0.3rem + 0.3vw)" }}
            >
              <strong>Fecha de inicio:</strong>
            </div>
            <div
              className="col-6 "
              style={{ fontSize: "calc(0.3rem + 0.3vw)" }}
            >
              {moment(challenge.start_date).format("DD/MM/YYYY")}
            </div>
          </div>

          <div className="mb-2 d-flex">
            <div
              className="col-6 text-start"
              style={{ fontSize: "calc(0.3rem + 0.3vw)" }}
            >
              <strong>Fecha de finalización:</strong>
            </div>
            <div className="col-6" style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
              {moment(challenge.end_date).format("DD/MM/YYYY")}
            </div>
          </div>
          <hr></hr>

          <div className="mb-3">
            <strong>Recompensa:</strong>
            <div className="mt-2" style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
              {challenge.reward}
            </div>
          </div>

          <div className="d-flex  mb-3">
            <div className="col-6" style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
              <strong>Puntos por participar:</strong>
              <div className="">{challenge.score_for_participating}</div>
            </div>
            <div className="col-6" style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
              <strong>Puntos por ganar:</strong>
              <div className="">+{challenge.score_for_winning}</div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="w-100">
          <div className="mb-3">
            <strong>
              Usuarios registrados({challenge.participants.length})
            </strong>
          </div>
          <div className="w-100">
            {challenge.participants.map((participant) => (
              <div key={participant.id} className="d-flex align-items-center">
                <div className="col-6 text-start">
                  <div style={{ fontSize: "calc(0.3rem + 0.3vw)" }}>
                    * {participant.name}
                  </div>
                </div>
                <div className="col-6 text-end">
                  <small
                    className="text-muted"
                    style={{ fontSize: "calc(0.3rem + 0.3vw)" }}
                  >
                    {participant.email}
                  </small>
                </div>
              </div>
            ))}
          </div>
        </div>
        <hr></hr>
        <div className="d-flex flex-column align-items-center mb-3">
          <strong>Descripción:</strong>
          <p
            className="text-muted mt-2"
            style={{ fontSize: "calc(0.3rem + 0.3vw)" }}
          >
            {challenge.description}
          </p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default ChallengeCard;
